import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RadioButtonModule as PRadioButtonModule } from 'primeng/radiobutton';
import { RadioButtonComponent } from './radio-button.component';

@NgModule({
  imports: [
    CommonModule,
    PRadioButtonModule,
    FormsModule,
    RadioButtonComponent,
  ],
  exports: [RadioButtonComponent],
})
export class RadioButtonModule {}
